
export function getUnitName(shortAddress) {
  const unitRegex = /Unit:\s*(\d+[A-Za-z]?)/
  const match = shortAddress.match(unitRegex)

  if (match) {
    const unitName = match[1]
    return unitName
  }

  return ''
}

export function getShortAddr(shortAddress) {
  const addr = shortAddress.split(' - Unit: ')[0]

  if (addr) {
    return addr
  }

  return ''
}